import React from 'react';

import SvgContainer from '../SvgContainer';

const Search = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100958)">
                <path d="M11.9456 10.5744C11.6188 10.2469 11.1751 10.0629 10.7124 10.0629L10.4563 9.81589C11.3528 8.77301 11.8925 7.4191 11.8925 5.94625C11.8925 2.66209 9.23042 0 5.94625 0C2.66209 0 0 2.66209 0 5.94625C0 9.23042 2.66209 11.8925 5.94625 11.8925C7.4191 11.8925 8.77301 11.3528 9.81589 10.4563L10.0629 10.7124C10.0629 11.1751 10.2469 11.6188 10.5744 11.9456L13.9547 15.3191C14.3316 15.6953 14.942 15.695 15.3185 15.3185C15.695 14.942 15.6953 14.3316 15.3191 13.9547L11.9456 10.5744ZM5.94625 10.0629C3.66838 10.0629 1.82962 8.22413 1.82962 5.94625C1.82962 3.66838 3.66838 1.82962 5.94625 1.82962C8.22413 1.82962 10.0629 3.66838 10.0629 5.94625C10.0629 8.22413 8.22413 10.0629 5.94625 10.0629Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100958">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Search;
